import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";


export const fetchCaseData = createAsyncThunk("case/fetchData", async ({perPage}) => {
    try {
        const response = await api.get("/cases", {
            params: {
                perPage: perPage,
            },
        });
            console.log("p : ",perPage)
        const data = response.data.cases;
        return data;
    } catch (error) {
        return error;
    }
});

export const caseSlice = createSlice({
    name: "case",
    initialState: {
        loading: false,
        error: null,
        cases: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchCaseData.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchCaseData.fulfilled, (state, action) => {
                state.loading = false;
                state.cases = action.payload;
            })
            .addCase(fetchCaseData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});

export default caseSlice.reducer;
